module.exports = __webpack_public_path__ + "components/MapControl/svg/Motel.svg?c743920a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Motel.svg
// module id = 2069
// module chunks = 0